import React, { Component } from 'react'
import ViewReceipt from './ViewReceipt'
import Receipts from '../../../../../api/Sales/Receipts'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { message } from 'antd'
import { assign, omit, pick, set } from 'lodash'
import { execute, idMaker, numVal } from '../../../../../modules/Utils'
import Documents from '../../../../../api/Documents'

class ViewReceiptCont extends Component {
  constructor(props) {
    super(props)
    this.key = props.match.params.key
    this.state = {
      fetching: false,
      fetchingLines: false,
      receipt: {},
      actions: [],
    }
    this.api = new Receipts()
    this.docsApi = new Documents()
    this.formRef = React.createRef()
    this.ids = idMaker()
  }

  componentDidMount() {
    this.fetch()
    this.fetchLines()
  }

  handleOps = async (operation, receipt) => {
    const { confirm, submit, revise, cancel, remove, reject } = this.api
    const { history } = this.props
    console.log({ operation })
    switch (operation) {
      case 'revise':
        await execute(this, revise.bind(this, pick(receipt, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'update':
        this.onEdit()
        break
      case 'submit':
        await execute(this, submit.bind(this, pick(receipt, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'cancel':
        await execute(this, cancel.bind(this, pick(receipt, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'remove':
        try {
          await execute(this, remove.bind(this, pick(receipt, ['_key', '_rev', '_id'])), message)
          history.replace({
            pathname: `/clients/payments/`,
            hash: 'receipts',
          })
        } catch (e) {}
        break
      case 'confirm':
        await execute(this, confirm.bind(this, pick(receipt, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'reject':
        await execute(this, reject.bind(this, pick(receipt, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
    }
  }
  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const receipt = await this.api.read(this.key)
      this.setState({
        receipt,
      })
      const actions = await this.docsApi.actions('receipts', receipt.status)

      this.setState({
        fetching: false,
        actions,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        fetching: false,
      })
    }
  }
  fetchLines = async () => {
    this.setState({ fetchingLines: true })
    try {
      let lines = await this.api.lines.list(this.key)
      lines = lines.map((target) => {
        target.newBalance =
          numVal(target, 'converted.gross') -
          (numVal(target, 'amount') +
            numVal(target, 'converted.paid') +
            numVal(target, 'discount') +
            numVal(target, 'bankFees') +
            numVal(target, 'exchangeLoss') +
            numVal(target, 'invoice.wtax.tax'))
        return target
      })

      this.setState({
        lines,
        cachedLines: lines,
      })
    } catch (e) {
      message.error(e.errorMessage)
    }
    this.setState({ fetchingLines: false })
  }
  onEdit = () => {
    this.setState({
      visible: true,
      type: 'edit',
    })
  }
  onCancel = () => {
    this.setState({
      visible: false,
    })
    this.formRef.current.resetFields()
  }
  update = async () => {
    await this.checkForm()
    try {
      let { receipt, values } = this.state
      this.setState({
        submitting: true,
      })
      await this.api.update(
        omit(assign(values, pick(receipt, ['_id', '_rev', '_key'])), [
          'transaction',
          'code',
          'status',
          '_history',
          'company',
          'revision',
          'allocated',
        ])
      )
      this.setState({
        submitting: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  confirm = async () => {
    try {
      let { receipt } = this.state
      this.setState({
        submitting: true,
      })
      await this.api.confirm(pick(receipt, ['_key', '_id', '_rev']))
      this.setState({
        submitting: false,
      })
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.setState({
            values,
          })
          res(true)
        }
      })
    })
  }
  handleChange = (value, _key, column) => {
    const newData = [...this.state.lines]
    const target = newData.find((item) => _key === item._key)
    if (target) {
      if (column === 'tax.type') {
        value === 'zer' && set(target, 'tax.rate', 0)
      }
      set(target, column, value)
      this.setState({ lines: newData })
    }
  }
  onShowPayLine = (payLine = {}, payLineModalType = 'new') => {
    this.setState({
      visiblePayLine: true,
      payLine,
      payLineModalType,
    })
  }
  onCancelPayLine = () => {
    this.setState({
      visiblePayLine: false,
      payLine: {},
    })
  }
  removeLine = async () => {
    try {
      this.setState({
        removingLine: true,
      })
      const { payLine } = this.state
      await this.api.lines.remove(pick(payLine, ['_id', '_rev', '_key']))
      this.setState({
        removingLine: false,
      })
      this.onCancelPayLine()
      await this.fetchLines()
    } catch (error) {
      this.setState({
        removingLine: false,
      })
      console.error(error)
      message.error(error.errorMessage)
    }
  }
  addLine = async () => {
    let payLine = await this.checkPayLineFrom()
    try {
      this.setState({
        submittingLine: true,
      })
      await this.api.lines.add(payLine)
      this.setState({
        submittingLine: false,
      })
      this.onCancelPayLine()
      await this.fetchLines()
    } catch (error) {
      this.setState({
        submittingLine: false,
      })
      console.error(error)
      message.error(error.errorMessage)
    }
  }
  updateLine = async () => {
    let payLine = await this.checkPayLineFrom()
    try {
      this.setState({
        submittingLine: true,
      })
      await this.api.lines.update(omit(payLine, ['amount']))
      this.setState({
        submittingLine: false,
      })
      this.onCancelPayLine()
      await this.fetchLines()
    } catch (error) {
      this.setState({
        submittingLine: false,
      })
      console.error(error)
      message.error(error.errorMessage)
    }
  }
  payLineFormRef = React.createRef()
  checkPayLineFrom = async () => {
    return new Promise((res, rej) => {
      this.payLineFormRef.current.props.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.error(err)
          res({
            ...pick(this.state.payLine, ['_id', '_rev', '_key']),
            ...values,
          })
        }
      })
    })
  }
  syncClient = async () => {
    try {
      const { receipt } = this.state
      this.setState({
        fetching: true,
      })
      await this.api.syncClient(pick(receipt, ['_id', '_rev', '_key']))
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  linesOps = {
    cancel: (_key) => {
      let lines = [...this.state.lines]
      let target = lines.find((item) => _key === item._key)
      if (target) {
        target = { ...this.state.cachedLines.find((item) => _key === item._key) }
        delete target.editable
        if (Object.keys(target).length === 1 && Object.keys(target)[0] === '_key')
          this.remove(target._key)
        else this.setState({ lines: lines })
      }
    },
    remove: async (_key) => {
      const newData = [...this.state.lines]
      const target = newData.find((item) => _key === item._key)
      if (target) {
        this.setState({
          fetchingLines: true,
        })
        await this.api.lines.remove(pick(target, ['_id', '_rev', '_key']))
        await this.fetchLines()
      }
    },
    edit: (_key) => {
      const newData = [...this.state.lines]
      const target = newData.filter((item) => _key === item._key)[0]
      if (target) {
        target.editable = true
        this.setState({ lines: newData })
      }
    },
    save: async (_key) => {
      const newData = [...this.state.lines]
      const target = newData.find((item) => _key === item._key)
      if (target) {
        this.setState({
          fetchingLines: true,
        })
        await this.api.lines.update(pick(target, ['_id', '_rev', '_key', 'amount', 'discount']))
        await this.fetchLines()
      }
    },
  }

  render() {
    return (
      <ViewReceipt
        {...this.state}
        {...pick(this, [
          'fetchLines',
          'onEdit',
          'handleOps',
          'onCancel',
          'update',
          'formRef',
          'fetch',
          'linesOps',
          'syncClient',
          'removeLine',
          'addLine',
          'updateLine',
          'handleChange',
          'onShowPayLine',
          'onCancelPayLine',
          'payLineFormRef',
        ])}
      />
    )
  }
}

ViewReceiptCont.propTypes = {}
ViewReceiptCont.defaultProps = {}

export default compose(withRouter)(ViewReceiptCont)
